module.exports = __webpack_public_path__ + "site/img/52.73c089d6.jpg";